/**
 * Story 8.12 — Onglet Documents en lecture seule (modale profil membre)
 * Affiche la liste des documents uploadés avec type, nom et taille.
 * Téléchargement INTERDIT (sécurité).
 */
import React from 'react';
import type { ProfileData } from '../../../../../services/profileService';

interface ReadOnlyDocumentsProps {
    data: ProfileData;
}

const formatFileSize = (bytes?: number): string => {
    if (!bytes) return '-';
    if (bytes < 1024) return `${bytes} o`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
};

const ReadOnlyDocuments: React.FC<ReadOnlyDocumentsProps> = ({ data }) => {
    const { documents, documents_status } = data;

    return (
        <div className="readonly-tab readonly-documents">
            <section className="readonly-section">
                <div className="readonly-section-title">Documents obligatoires</div>

                {/* Statut des documents requis */}
                {documents_status && documents_status.length > 0 && (
                    <div className="readonly-doc-status-list">
                        {documents_status.map((ds) => (
                            <div key={ds.type} className="readonly-doc-status-row">
                                <span className={`readonly-doc-status-badge ${ds.uploaded ? 'uploaded' : 'missing'}`}>
                                    {ds.uploaded ? '✓' : '✗'}
                                </span>
                                <span className="readonly-doc-status-label">{ds.label}</span>
                                <span className="readonly-doc-status-required">
                                    {ds.required ? 'Obligatoire' : 'Facultatif'}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </section>

            <section className="readonly-section">
                <div className="readonly-section-title">Documents uploadés</div>

                {(!documents || documents.length === 0) ? (
                    <p className="readonly-empty">Aucun document uploadé.</p>
                ) : (
                    <table className="readonly-doc-table">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Nom du fichier</th>
                                <th>Taille</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents.map((doc) => (
                                <tr key={doc.id}>
                                    <td>{doc.type_label || doc.type}</td>
                                    <td>{doc.filename || '-'}</td>
                                    <td>{formatFileSize(doc.filesize)}</td>
                                    <td>{doc.created_at ? new Date(doc.created_at).toLocaleDateString('fr-FR') : '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                <p className="readonly-doc-notice">
                    Le téléchargement des documents n'est pas disponible en mode consultation.
                </p>
            </section>
        </div>
    );
};

export default ReadOnlyDocuments;
